<div class="empty-state">
  <div class="empty-state__icon-wrap"><i class="empty-state__icon" [ngClass]="iconClass"></i></div>
  <h3 class="empty-state__heading">{{heading}}</h3>
</div>